import { fetchAuthSession } from "aws-amplify/auth";

export const getAuthToken = async (): Promise<string> => {
  try {
    const session = await fetchAuthSession();
    return session.tokens?.idToken?.toString() ?? "";
  } catch {
    return "";
  }
};
